import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, BoxIcon } from "lucide-react";
export interface Kpi {
  label: string;
  value: string;
  to: string;
  icon: BoxIcon;
  /** Fremhæver kortet med guldkant, når der er noget at tage sig af. */
  attention?: boolean;
}
export function KpiCards({
  items
}: {
  items: Kpi[];
}) {
  return <ul className="grid grid-cols-2 gap-3 md:gap-4 xl:grid-cols-4" data-id="element-328" data-mp="7b4f9vbnujfr">
      {items.map(kpi => <li key={kpi.label} data-id="element-329" data-mp="35wnshxfihc7b">
          <Link to={kpi.to} className={`group flex h-full flex-col rounded-card border bg-white p-4 transition-colors duration-150 ease-smooth hover:border-accent/50 md:p-5 ${kpi.attention ? 'border-accent/40' : 'border-line'}`} data-id="element-330" data-mp="3atxdn0vvb1pc">
            <div className="flex items-start justify-between" data-id="element-331" data-mp="3kjz2huw1oo5b">
              <kpi.icon className="h-6 w-6 text-accent md:h-7 md:w-7" strokeWidth={1.6} aria-hidden="true" data-id="element-332" data-mp="3kljupduvzv00" />
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-line text-ink-muted transition-colors duration-150 group-hover:border-accent/50 group-hover:text-accent" data-id="element-333" data-mp="2s3fxdvs81ykv">
                <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-334" data-mp="15azo98j0eyna" />
              </span>
            </div>
            <p className="mt-5 whitespace-nowrap font-display text-[clamp(1.5rem,3.4vw,2.1rem)] font-bold leading-none tracking-tight text-ink" data-id="element-335" data-mp="10k141xuwhger">
              {kpi.value}
            </p>
            <p className="mt-2 text-sm text-ink-soft md:text-[15px]" data-id="element-336" data-mp="rknu742v6pti">{kpi.label}</p>
          </Link>
        </li>)}
    </ul>;
}